import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'
var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)
import styled from 'styled-components'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { Formik, Field } from 'formik'
import * as UpChunk from '@mux/upchunk'
import { colors } from '../ui/helpers.js'
import { H1, H3, H6, Text, Span, GradientFont, Error, SmallTitle, Label } from '../ui/Typography.js'
import { Flex, Box, Container } from '../ui/Layout.js'
import Image from '../ui/Image.js'
import Tooltip from '../ui/Tooltip.js'
import Icon from '../ui/Icon.js'
import Button from '../ui/Button.js'
import { BigDarkSpinner } from '../ui/Spinner.js'
import VideoPlayer from '../Components/VideoPlayer'
import ProcessingPreview from '../Components/ProcessingPreview'
import formikFormWrapper from '../formikFormWrapper.js'
import api from '../api.js'
import { toast } from 'react-toastify'
import { useAuth } from '../Auth.js'
import { useVideos } from '../VideoProvider.js'
import ChatButton, { openChat } from '../Components/ChatButton'
import { useModal } from '../Modal.js'
import ReactTooltip from 'react-tooltip'
import PricingCards from '../Components/PricingCards.js'
import { use } from 'react'

const Grid = styled(Flex)`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 35px;
  padding-left: 35px;
  padding-right: 35px;
  @media (max-width: 1400px) {
    grid-gap: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (max-width: 1300px) {
    grid-gap: 8px;
    padding-left: 8px;
    padding-right: 8px;
  }
`

const PlanContainer = styled(Flex)`
  border: 1px solid #a0aec0;
  border-radius: 16px;
  background-color: white;
  flex-direction: column;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
`

const MostPopular = styled(Flex)`
  background: linear-gradient(225deg, #bb65ff 0%, #4c6fff 100%);
  padding: 3px;
  border-radius: 19px;
  position: relative;
`

const MostPopularText = styled(Box)`
  width: 112px;
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translate(-50%, 0);
  background: linear-gradient(225deg, #bb65ff 0%, #4c6fff 100%);
  border-radius: 12px;
  padding: 4px;
  padding-left: 12px;
  padding-right: 12px;
`

const Billing = (props) => {
  let { user, setUser } = useAuth()
  console.log(user)
  const navigate = useNavigate()

  const canAlwaysSelectFree = props.canAlwaysSelectFree
  const [showSpinner, setShowSpinner] = useState(false)
  const [isAnnual, setIsAnnual] = useState(() => {
    if (user?.shopifyShopUrl) return false
    return true
  })

  // useEffect(() => {
  //   setIsAnnual(!user?.shopifyShopUrl)
  // }, [user?.shopifyShopId])

  const plansToShow = props.plansToShow || [1, 5, 6, 7]

  // THIS SHIT IS NOW DUPLICATE
  // THIS SHIT IS NOW DUPLICATE
  // See: ../Components/PaywallModal.js
  const addPlan = async (planId) => {
    setShowSpinner(true)
    if (user.shopifyShopUrl) {
      return addShopifyPlan(planId)
    } else {
      return addStripePlan(planId)
    }
  }

  const addShopifyPlan = async (planId) => {
    const res = await api.post('/shopify/create-subscription', { planId, redirectUrl: props.redirectUrl, isAnnual: isAnnual })
    if (res.data.payload.isFree) {
      window.location.href = props.redirectUrl
    }
    const redirectUrl = res.data.payload.redirectUrl
    if (redirectUrl) {
      window.location.href = redirectUrl
    }
  }

  const addStripePlan = async (planId) => {
    const res = await api.post('/stripe/create-subscription', {
      planId,
      redirectUrl: props.redirectUrl,
      isAnnual: isAnnual,
      tolt: window.tolt_referral
    })
    if (res.data.payload.isFree) {
      window.location.href = props.redirectUrl
    }
    const redirectUrl = res.data.payload.redirectUrl
    if (redirectUrl) {
      window.location.href = redirectUrl
    }
  }
  // THIS SHIT IS NOW DUPLICATE
  // THIS SHIT IS NOW DUPLICATE

  return (
    <Flex flexDirection="column" alignItems="center" px={props.px || 0}>
      <PricingCards
        plansToShow={plansToShow}
        canAlwaysSelectFree={canAlwaysSelectFree}
        isAnnual={isAnnual}
        setIsAnnual={setIsAnnual}
        addPlan={addPlan}
        showSpinner={showSpinner}
      />
      <Flex mt="32px">
        <PlanContainer>
          <Flex mb="16px" alignItems="center">
            <Flex>
              <Text fontSize="18px" fontWeight="700" ml="16px" mr="40px">
                Enterprise
              </Text>
              <Text mr="40px">
                For custom scale plans, special use cases, whitelabelling, premium strategy support, complete customisation and
                much more, get in touch.
              </Text>
            </Flex>
            <Flex justifyContent="flex-end" width="auto">
              <Button width="218px" large variant="white" borderColor="black" label="Contact Sales" onClick={() => openChat()} />
            </Flex>
          </Flex>
        </PlanContainer>
      </Flex>
    </Flex>
  )
}

export default Billing
